import { render } from "./AppointmentBooking.vue?vue&type=template&id=da1728a6&scoped=true"
import script from "./AppointmentBooking.vue?vue&type=script&lang=js"
export * from "./AppointmentBooking.vue?vue&type=script&lang=js"

import "./AppointmentBooking.vue?vue&type=style&index=0&id=da1728a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1728a6"]])

export default __exports__